import {DrawerNavigationCategoryTree_TreeItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/drawer_navigation.types';
import {tabFocusedStyles, UnstyledLink} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC, MouseEventHandler} from 'react';

type HandleClickType = MouseEventHandler<HTMLAnchorElement>;

export const CategoryItemWrapper: FC<
  React.PropsWithChildren<{
    item: DrawerNavigationCategoryTree_TreeItem;
    handleClick: HandleClickType;
    onCategoryClick?: React.MouseEventHandler<HTMLLIElement>;
  }>
> = ({item, handleClick, children, onCategoryClick}) => {
  const {path, name} = item.category;
  const {categoryPreview} = item;

  if (!categoryPreview) {
    return null;
  }

  if (
    categoryPreview.$case === 'productsCount' &&
    categoryPreview.productsCount.count <= 0
  ) {
    return null;
  }
  if (
    categoryPreview.$case === 'categoryImage' &&
    !categoryPreview.categoryImage.src
  ) {
    return null;
  }
  return (
    <li
      data-testid={`categoryTreeNavigationItem_${name}`}
      onClick={onCategoryClick}
      tabIndex={-1}
    >
      <Link to={path} onClick={handleClick} aria-label={undefined}>
        {children}
      </Link>
    </li>
  );
};

const Link = styled(UnstyledLink)`
  &:focus-visible {
    ${tabFocusedStyles()}
  }
`;
